import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";
import { FilterProps } from "../filter-definition";
import { ProductFilter } from "../GenericFilters/ProductFilter";
import { useGetDocumentContractFilterDimensions } from "hooks/api/documents/documentFilterDimensions";
import useFeatureFlag from "hooks/useFeatureFlag";
import { DOCUMENTS } from "util/featureFlags";

export const ContractsProductFilter = ({ variant }: FilterProps) => {
  const cardCodes = useSelectedCustomerCode();
  const { data, isLoading } = useGetDocumentContractFilterDimensions(cardCodes);

  const productOptions = data?.products;

  const isDocumentFilterFeatureEnabled = useFeatureFlag(
    DOCUMENTS.FILTER_BUTTONS
  );

  if (!isDocumentFilterFeatureEnabled) {
    return null;
  }

  return (
    <ProductFilter
      filterKey="product"
      name="Product"
      variant={variant}
      productOptions={productOptions}
      isLoading={isLoading}
    />
  );
};
